module.exports = "img/flags/NR.628ddba.png";